import * as React from 'react';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import styled from "styled-components";
import {Ratings} from "../common/RatingDisplays";

const ratingLabels = {
    1: 'Very Poor',
    1.5: 'Very Poor',
    2: 'Poor',
    2.5: 'Poor',
    3: 'Good',
    3.5: 'Good',
    4: 'Very Good',
    4.5: 'Very Good',
    5: 'Excellent',
};

const Label = styled.div`
    margin-left: 8px;
`

const getLabelText = (value) => {
    return `${value} Star${value !== 1 ? 's' : ''}, ${ratingLabels[value]}`;
};

export default function DescriptiveRating({ onChange, value, readOnly, size }) {
    const [hover, setHover] = React.useState(-1);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Ratings
                name="hover-feedback"
                value={value}
                precision={1}
                readOnly={readOnly}
                size={size}
                getLabelText={getLabelText}
                onChange={onChange}
                onChangeActive={(event, newHover) => {
                    setHover(newHover);
                }}
                emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
            />
            {value !== null && (
                <Label>{ratingLabels[hover !== -1 ? hover : value]}</Label>
            )}
        </Box>
    );
}